<template>
  <div>
    <HotTable
      ref="hotTableComponent"
      :settings="hotSettings"
      :data="receivables">
    </HotTable>
  </div>

</template>

<script>
  import { HotTable } from '@handsontable/vue';
  import { registerAllModules } from "handsontable/registry";

  registerAllModules();

  import "handsontable/dist/handsontable.full.min.css";

  export default {
    props: {
        hotHeaders : Array,
        hotColumns : Array,
        receivableGiroData : Array,
    },
    data () {
      console.log("hot : ", this.receivableGiroData);

      return {
        receivables: this.receivableGiroData
      }
    },
    components: {
      HotTable
    },
    methods: {
      getHotSettings() {
        this.hotSettings = {
          licenseKey: "non-commercial-and-evaluation",
          height: 600,
          width: "100%",
          stretchH: "all",
          dropdownMenu: true,
          filters: true,
          columnSorting: true,
          autoColumnSize: true,
          autoRowSize: true,
          colHeaders: this.hotHeaders,
          columns: this.hotColumns,
          afterViewRender: (stateFilter) => {
            if (this.$refs.hotTableComponent) {
            this.hotInstance = this.$refs.hotTableComponent.hotInstance;
            const filteredData = this.hotInstance.getData();
            this.$emit('setHotGiroData', filteredData)
            }
          },
        };
      },

    },
    components: {
      HotTable
    },
    beforeMount() {
      this.getHotSettings();
    },
}
</script>

<style>
  .handsontable .warning-bg {
    background-color: yellow;
  }
  .handsontable .default-bg {
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// cHotGiroDueDate.vue?4fb6985b